<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRiChengList"
      data-title="接送机"
    ></div>
    <div
      class="content c-table-box mt-2 rounded-lg overflow-y-auto flex flex-col gap-y-3"
    >
      <div
        class="bg-white p-4 rounded-lg mb-3 flex flex-col text-xs gap-y-3"
        v-for="item in state.list_data"
        :key="item"
      >
        <ul
          class="grid gap-x-3 items-center"
          style="grid-template-columns: auto auto 1fr auto"
        >
          <strong
            class="text-green-700 cursor-pointer hover:underline text-base"
            @click="
              $openMenu({
                path: 'HuiYiDetailRiChengDetail',
                title: '日程详情-' + item.number,
                refresh: true,
                data: {
                  id: item.id,
                },
              })
            "
          >
            {{ item.name }}
          </strong>
          <text class="text-gray-700 text-sm">{{ item.sj }}</text>
          <text class="text-gray-400 text-xs ml-3">{{ item.rq }}</text>
          <el-button type="primary" size="small">待接送</el-button>
        </ul>
        <ul
          class="gap-x-5 grid items-start"
          style="grid-template-columns: 0.5fr 1fr"
        >
          <c_cell
            :size="12"
            title="接客地点"
            :value="item.jkdd"
            class="min-w-0"
          />
          <c_cell
            :size="12"
            title="详细地址"
            :value="item.jkdz"
            class="min-w-0 !items-start"
          />
        </ul>
        <ul
          class="gap-x-5 grid items-start"
          style="grid-template-columns: 0.5fr 1fr"
        >
          <c_cell
            :size="12"
            title="送客地点"
            :value="item.skdd"
            class="min-w-0"
          />
          <c_cell
            :size="12"
            title="详细地址"
            :value="item.skdz"
            class="min-w-0 !items-start"
          />
        </ul>
        <ul class="flex gap-x-5">
          <c_cell :size="12" title="司机信息">
            <template #default>
              <text>{{ item.sjxm }}</text>
              <tex class="text-gray-400 text-xs">{{ item.sjdh }}</tex>
            </template>
          </c_cell>
          <c_cell :size="12" title="车牌" :value="item.cph" />
          <c_cell :size="12" title="车辆类型" :value="item.cllx" />
          <c_cell :size="12" title="车辆型号" :value="item.clxh" />
          <c_cell :size="12" title="核载人数" :value="item.hzrs" />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
export default {
  setup() {
    const state = reactive({});
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      state.list_data = [
        {
          id: 1,
          name: "科技大学嘉宾接机",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          jkdd: "合肥南站",
          jkdz: "安徽省合肥市包河区徽州大道与庐州大道之间",
          skdd: "金鳞大酒店",
          skdz: "安徽省合肥市瑶海区戚继光路与明皇路交口向南100米路东",
          sjxm: "李鹏飞",
          sjdh: "13888888888",
          cph: "皖A88888",
          cllx: "SUV",
          clxh: "奔驰",
          hzrs: 5,
        },
        {
          id: 2,
          name: "科技大学嘉宾接机",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          jkdd: "合肥南站",
          jkdz: "安徽省合肥市包河区徽州大道与庐州大道之间",
          skdd: "金鳞大酒店",
          skdz: "安徽省合肥市瑶海区戚继光路与明皇路交口向南100米路东",
          sjxm: "李鹏飞",
          sjdh: "13888888888",
          cph: "皖A88888",
          cllx: "SUV",
          clxh: "奔驰",
          hzrs: 5,
        },
        {
          id: 3,
          name: "科技大学嘉宾接机",
          sj: "10:00 ~ 12:00",
          rq: "2025-12-21",
          jkdd: "合肥南站",
          jkdz: "安徽省合肥市包河区徽州大道与庐州大道之间",
          skdd: "金鳞大酒店",
          skdz: "安徽省合肥市瑶海区戚继光路与明皇路交口向南100米路东",
          sjxm: "李鹏飞",
          sjdh: "13888888888",
          cph: "皖A88888",
          cllx: "SUV",
          clxh: "奔驰",
          hzrs: 5,
        },
      ];
    };
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
